// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"391":"49beb43c","443":"49beb43c"}[chunkId] + ".chunk.css";
};